import React from 'react'
import Navbar from './Navbar'
import RegisterForm from './RegisterForm'
import Footer from './Footer'

export default function RegisterPage() {
    return (
        <>
            <Navbar />
            <RegisterForm/>
            <Footer />
        </>
    )
}
